"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import Image from "next/image";
import Link from "next/link";

export function SimpleFooter() {
  const clientConfig = useClientConfig();
  const footer = clientConfig?.layoutSetting?.footer;

  const paskerContent = footer?.footerContents?.find((it) => it.title === "Pusat Pasar Kerja") || null;
  const paskerContacts =
    paskerContent?.contacts && paskerContent?.contacts?.length > 0 ? paskerContent?.contacts.flatMap((it) => it.list) : [];

  return (
    <>
      <div className="text-center space-y-4">
        <div className="text-sm font-normal text-gray-500">
          Butuh bantuan?{" "}
          <a href="https://kemnaker.go.id/information/contact" className="font-bold text-primary">
            Kunjungi Pusat Bantuan
          </a>
          {paskerContacts.length > 0 ? " atau hubungi kami" : ""}
        </div>
        {paskerContacts.length > 0 && (
          <div className="flex items-center gap-5 flex-wrap justify-center text-center text-sm">
            {paskerContacts.map((contactItem) => {
              return (
                <Link key={contactItem.id} href={contactItem.href} target={contactItem.target} className="inline-flex items-center">
                  {contactItem.icon && (
                    <Image
                      src={contactItem.icon?.url}
                      alt={contactItem.icon?.alternativeText || contactItem.icon?.name}
                      width={contactItem.icon?.width || 20}
                      height={contactItem.icon?.height || 20}
                      className="size-5 mr-1"
                    />
                  )}
                  <span className="font-medium text-gray-500">{contactItem.text}</span>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
